module.exports = __webpack_public_path__ + "img/users-02.eea3616b.svg";